import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const apiUrl = import.meta.env.VITE_API_URL;

const ConstructionNavbar = () => {
  const location = useLocation();
  const [logo, setLogo] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(localStorage.getItem('selectedCountry') || 'bangladesh');
  const [showCountryModal, setShowCountryModal] = useState(false);

  // Fetch logo from API
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await fetch(`${apiUrl}/layout/navbar/`);
        const data = await response.json();
        setLogo(data.logo);
      } catch (error) {
        console.error('Error fetching logo:', error);
        setLogo(
          "/builders.png"
        );
      }
    };

    fetchLogo();
  }, []);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle country change
  const handleCountryChange = (country) => {
    localStorage.setItem('selectedCountry', country);
    setSelectedCountry(country);
    setShowCountryModal(false);
    window.location.reload(); // Refresh to apply country-specific changes
  };

  // Check if link is active
  const isActive = (path) => {
    return location.pathname === path || 
           (path !== '/' && location.pathname.startsWith(path));
  };

  return (
    <>
      <header className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-[#040404] shadow-xl py-1 border-b border-[#f9b414]/20' : 'bg-[#040404]/95 py-3'}`}>
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center">
              {logo ? (
                typeof logo === 'string' && logo.startsWith('http') ? (
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-[#f9b414]/20 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="relative bg-white/90 p-2 rounded-lg shadow-md">
                      <img 
                        src={logo} 
                        alt="Company Logo" 
                        className="h-12 md:h-14 object-contain"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="relative bg-white/90 p-2 rounded-lg shadow-md">
                      <img 
                        src="/builders.png" 
                        alt="Company Logo" 
                        className="h-12 md:h-14 object-contain"
                      />
                    </div>
                )
              ) : (
                 <div className="relative bg-white/90 p-2 rounded-lg shadow-md">
                      <img 
                        src="/builders.png" 
                        alt="Company Logo" 
                        className="h-12 md:h-14 object-contain"
                      />
                    </div>
              )}
            </div>

            {/* Centered Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1 absolute left-1/2 transform -translate-x-1/2">
              <Link 
                to="/" 
                className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                  isActive('/') 
                    ? 'text-white bg-[#7bbf42] shadow-md' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white'
                }`}
              >
                Home
             
                {!isActive('/') && (
                  <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#f9b414] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                )}
              </Link>
              
              <Link 
                to="/about" 
                className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                  isActive('/about') 
                    ? 'text-white bg-[#7bbf42] shadow-md' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white'
                }`}
              >
                About
            
                {!isActive('/about') && (
                  <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#f9b414] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                )}
              </Link>
              
              <Link 
                to="/service" 
                className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                  isActive('/service') 
                    ? 'text-white bg-[#7bbf42] shadow-md' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white'
                }`}
              >
                Services
             
                {!isActive('/service') && (
                  <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#f9b414] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                )}
              </Link>
              
              {/* Conditionally show Man Power link for Saudi Arabia */}
              {selectedCountry === 'saudiarabia' && (
                <Link 
                  to="/man-power" 
                  className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                    isActive('/manpower') 
                      ? 'text-white bg-[#f9b414] shadow-md' 
                      : 'text-gray-100 hover:bg-[#f9b414]/20 hover:text-white'
                  }`}
                >
                  Manpower Supply
               
                  {!isActive('/manpower') && (
                    <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#7bbf42] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                  )}
                </Link>
              )}
              
              <Link 
                to="/project" 
                className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                  isActive('/project') 
                    ? 'text-white bg-[#7bbf42] shadow-md' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white'
                }`}
              >
                Projects
          
                {!isActive('/project') && (
                  <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#f9b414] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                )}
              </Link>
              
              <Link 
                to="/contact" 
                className={`px-4 py-3 font-medium rounded-lg transition-all group relative ${
                  isActive('/contact') 
                    ? 'text-white bg-[#7bbf42] shadow-md' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white'
                }`}
              >
                Contact
            
                {!isActive('/contact') && (
                  <span className="absolute bottom-1 left-1/2 transform -translate-x-1/2 h-0.5 bg-[#f9b414] w-0 group-hover:w-3/4 transition-all duration-300"></span>
                )}
              </Link>
            </nav>

            {/* Right side elements */}
            <div className="flex items-center space-x-4">
              {/* Country Switcher Button - Always visible */}
              <button
                onClick={() => setShowCountryModal(true)}
                className={`hidden lg:flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all ${
                  selectedCountry === 'bangladesh' 
                    ? 'bg-[#7bbf42]/20 text-white border border-[#7bbf42]' 
                    : 'bg-[#f9b414]/20 text-white border border-[#f9b414]'
                } hover:bg-opacity-30 group`}
              >
                {selectedCountry === 'bangladesh' ? (
                  <>
                    <span className="text-xl">🇧🇩</span>
                    <span>Bangladesh</span>
                  </>
                ) : (
                  <>
                    <span className="text-xl">🇸🇦</span>
                    <span>Saudi Arabia</span>
                  </>
                )}
                <svg className="w-4 h-4 ml-1 transform group-hover:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              
              {/* Get a Quote Button */}
              <div className="hidden lg:block relative group">
                <Link 
                  to="/quote" 
                  className={`px-6 py-3 rounded-lg shadow-lg font-bold transition-all flex items-center ${
                    isActive('/quote')
                      ? 'bg-[#7bbf42] text-white hover:bg-[#68a637]'
                      : 'bg-[#f9b414] text-[#040404] hover:bg-[#7bbf42] hover:text-white'
                  }`}
                >
                  Get a Quote
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </Link>
                <div className="absolute -bottom-1 left-0 h-1 bg-[#7bbf42] w-full rounded-b-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              {/* Mobile menu button */}
              <div className="lg:hidden flex items-center">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="p-2 rounded-lg bg-[#f9b414] text-[#040404] focus:outline-none hover:bg-[#7bbf42] transition-colors"
                  aria-label="Toggle menu"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {isMenuOpen ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    )}
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Navigation */}
          <div className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'} mt-2 pb-4 bg-[#040404] rounded-lg shadow-2xl border border-[#f9b414]/20`}>
            <div className="flex flex-col space-y-1 p-2">
              <Link 
                to="/" 
                className={`px-4 py-3 rounded-lg transition-all ${
                  isActive('/') 
                    ? 'bg-[#7bbf42] text-white font-semibold' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white font-medium'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`px-4 py-3 rounded-lg transition-all ${
                  isActive('/about') 
                    ? 'bg-[#7bbf42] text-white font-semibold' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white font-medium'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/service" 
                className={`px-4 py-3 rounded-lg transition-all ${
                  isActive('/service') 
                    ? 'bg-[#7bbf42] text-white font-semibold' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white font-medium'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              
              {/* Conditionally show Man Power link for Saudi Arabia in mobile */}
              {selectedCountry === 'saudiarabia' && (
                <Link 
                  to="/manpower" 
                  className={`px-4 py-3 rounded-lg transition-all ${
                    isActive('/manpower') 
                      ? 'bg-[#f9b414] text-[#040404] font-semibold' 
                      : 'text-gray-100 hover:bg-[#f9b414]/20 hover:text-[#040404] font-medium'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Manpower Supply
                </Link>
              )}
              
              <Link 
                to="/project" 
                className={`px-4 py-3 rounded-lg transition-all ${
                  isActive('/project') 
                    ? 'bg-[#7bbf42] text-white font-semibold' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white font-medium'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Projects
              </Link>
              <Link 
                to="/contact" 
                className={`px-4 py-3 rounded-lg transition-all ${
                  isActive('/contact') 
                    ? 'bg-[#7bbf42] text-white font-semibold' 
                    : 'text-gray-100 hover:bg-[#7bbf42]/20 hover:text-white font-medium'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              
              {/* Mobile Country Switcher */}
              <button
                onClick={() => setShowCountryModal(true)}
                className={`mt-2 px-4 py-3 rounded-lg font-medium transition-all flex items-center justify-center space-x-2 ${
                  selectedCountry === 'bangladesh' 
                    ? 'bg-[#7bbf42]/20 text-white border border-[#7bbf42]' 
                    : 'bg-[#f9b414]/20 text-white border border-[#f9b414]'
                }`}
              >
                {selectedCountry === 'bangladesh' ? (
                  <>
                    <span className="text-xl">🇧🇩</span>
                    <span>Switch to Saudi Arabia</span>
                  </>
                ) : (
                  <>
                    <span className="text-xl">🇸🇦</span>
                    <span>Switch to Bangladesh</span>
                  </>
                )}
              </button>
              
              <Link 
                to="/quote" 
                className={`mt-2 px-4 py-3 rounded-lg shadow-lg text-center transition-all font-bold ${
                  isActive('/quote')
                    ? 'bg-[#7bbf42] text-white hover:bg-[#68a637]'
                    : 'bg-[#f9b414] text-[#040404] hover:bg-[#7bbf42] hover:text-white'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Get a Quote
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Country Selector Modal */}
      {showCountryModal && (
        <div className="fixed inset-0 z-50 bg-[#040404]/90 backdrop-blur-sm flex justify-center items-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-[#7bbf42] to-[#f9b414] p-6">
              <h2 className="text-2xl font-bold text-white text-center">
                Switch Country
              </h2>
              <p className="text-white/90 text-center mt-1">
                Select your preferred country
              </p>
            </div>
            
            {/* Modal Body */}
            <div className="p-6 space-y-4">
              <button
                onClick={() => handleCountryChange('bangladesh')}
                className={`w-full flex items-center justify-between p-4 rounded-xl border-2 transition-all duration-300 group ${
                  selectedCountry === 'bangladesh' 
                    ? 'border-[#7bbf42] bg-[#7bbf42]/10' 
                    : 'border-[#7bbf42]/20 hover:border-[#7bbf42]'
                }`}
              >
                <div className="flex items-center space-x-4">
                  <span className="text-3xl">🇧🇩</span>
                  <div className="text-left">
                    <h3 className="font-bold text-[#040404] group-hover:text-[#7bbf42]">Bangladesh</h3>
                    <p className="text-sm text-[#040404]/80">Construction Services</p>
                  </div>
                </div>
                {selectedCountry === 'bangladesh' && (
                  <div className="w-6 h-6 rounded-full bg-[#7bbf42] flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                )}
              </button>

              <button
                onClick={() => handleCountryChange('saudiarabia')}
                className={`w-full flex items-center justify-between p-4 rounded-xl border-2 transition-all duration-300 group ${
                  selectedCountry === 'saudiarabia' 
                    ? 'border-[#f9b414] bg-[#f9b414]/10' 
                    : 'border-[#f9b414]/20 hover:border-[#f9b414]'
                }`}
              >
                <div className="flex items-center space-x-4">
                  <span className="text-3xl">🇸🇦</span>
                  <div className="text-left">
                    <h3 className="font-bold text-[#040404] group-hover:text-[#f9b414]">Saudi Arabia</h3>
                    <p className="text-sm text-[#040404]/80">Construction Services</p>
                  </div>
                </div>
                {selectedCountry === 'saudiarabia' && (
                  <div className="w-6 h-6 rounded-full bg-[#f9b414] flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                )}
              </button>
            </div>

            {/* Modal Footer */}
            <div className="bg-[#040404]/5 p-4 text-center">
              <button
                onClick={() => setShowCountryModal(false)}
                className="text-sm text-[#040404]/60 hover:text-[#7bbf42] transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConstructionNavbar;